const isNull = value => null === value;

export default isNull;
//# sourceMappingURL=isNull.js.map